var app = angular.module('leonardo');

var TemplateList = function (
  $scope,
  $filter,
  $timeout,
  $q,
  $controller,
  $stateParams,
  $rootScope,
  ngDialog,
  TemplateService,
  FilterService,
  $state,
  PermissionService,
  AttachmentService,
  AccountUserService,
  AuthDataService,
  PortfolioService,
  PropertyService,
  BrowserHistoryService
) {
  $scope.permissionService = PermissionService;
  $scope.accountUserService = AccountUserService;
  $scope.templateMode = $state.current.templateMode ? $state.current.templateMode : 'property';
  $scope.onboarding = $state.current.onboarding ? true : false;
  $scope.template_group = $state.current.template_group ? true : false;
  $scope.no_icon = $state.current.no_icon_descendants;
  $scope.templates = [];
  $scope.templatesGrouped = [];
  $scope.subcategoryExpanded = null;
  $scope.subcategoryExpanded_element = null;
  $scope.templateExpanded = null;
  $scope.templateService = TemplateService;
  $scope.authDataService = AuthDataService;
  $scope.group = false;
  $scope.options = [];

  $scope.showChangeStatusAll = function (disable) {
    if (disable) {
      ngDialog.open({
        template: 'views/templates/dialog/template/disable.html',
        controller: 'ChangeStatusAllDialog',
        data: {
          disable: disable
        }
      });
    } else {
      ngDialog.open({
        template: 'views/templates/dialog/template/enable.html',
        controller: 'ChangeStatusAllDialog',
        data: {
          disable: disable
        }
      });
    }
  };

  $scope.initData = function (template) {
    var data = {
      name: template.name,
      client_instance: AuthDataService.getClientInstance(),
      //white_label: AuthDataService.getWhiteLabel(),
      account: template.account,
      body: template.body,
      category: template.category,
      subcategory: template.subcategory,
      note_required: template.note_required,
      attachment_required: template.attachment_required,
      enabled: template.status == TemplateService.STATUS_PUBLISHED,
      never_fall_off: template.never_fall_off,
      value_item: template.value_item,
      recurrence_type: template.recurrence_type,
      recurrence: angular.copy(template.recurrence),
      priority: template.priority,
      attachments: [],
      permanence: template.permanence,
      fields: template.fields,
      date_from: template.date_from ? template.date_from : null,
      date_to: template.date_to ? template.date_to : null
    };

    data.status = data.enabled ? TemplateService.STATUS_PUBLISHED : TemplateService.STATUS_UNPUBLISHED;
    if (template.attachments && template.attachments.length > 0) {
      var ids = template.attachments.map(function (obj) {
        return obj.id ? obj.id : obj;
      });
      var filters = {
        disable_pagination: true,
        id: ids.join(',')
      };
      angular.forEach(AttachmentService.getlist(filters).$object, function (attachment) {
        data.attachments.push(attachment.id);
      });
    }

    return data;
  };

  $scope.containsId = function (array, id) {
    var contains = false;
    angular.forEach(array, function (value) {
      if (value.id === id) {
        contains = true;
      }
    });
    return contains;
  };

  $scope.submitActive = function (template) {
    if (!template) {
      return false;
    }
    if ($scope.onboarding) {
      return true;
    }
    if ($state.current.action === 'create') {
      return true;
    }
    return template.editable;
  };

  $scope.overrideActive = function (template) {
    if (!template) {
      return false;
    }
    if ($scope.onboarding) {
      return false;
    }
    if ($state.current.action === 'create') {
      return false;
    }
    return !template.editable && template.overridable;
  };

  $scope.updateTemplateList = function (data) {
    angular.forEach($scope.templates, function (template, key) {
      if (template.id == data.id) {
        $scope.templates[key] = data;
        $scope.groupTemplates();
        return;
      }
    });
  };

  $scope.expandTemplate = function (template) {
    var defer = $q.defer();
    if (template.editable || template.overridable) {
      if ($scope.isTemplateExpanded(template)) {
        $scope.templateExpanded = null;
        BrowserHistoryService.close(true);
        BrowserHistoryService.unregister('templateEdit' + template.id);
      } else {
        TemplateService.get(template.id).then(
          function (data) {
            angular.forEach($scope.templates, function (temp, key) {
              if (temp.id == data.id) {
                data.depth = $scope.templates[key].depth;
                var client_instance_name = $scope.templates[key].client_instance ? $scope.templates[key].client_instance.name : null;
                $scope.templates[key] = data;
                $scope.templates[key].client_instance_name = client_instance_name;
              }
            });
            if (!isNull($scope.templateExpanded)) {
              BrowserHistoryService.close(true);
              BrowserHistoryService.unregister('templateEdit' + $scope.templateExpanded);
            }
            $scope.templateExpanded = template.id;
            $timeout(function () {
              BrowserHistoryService.register('ngdialogTemplateEdit' + template.id, function () {
                $scope.expandTemplate(template);
              });
              BrowserHistoryService.show('ngdialogTemplateEdit' + template.id);
            }, 10);
            defer.resolve(data);
          },
          function (error) {
            defer.reject(error);
          }
        );
      }
    } else {
      defer.reject();
    }
    return defer.promise;
  };

  $scope.deleteTemplate = function (template) {
    ngDialog
      .openConfirm({
        templateUrl: 'views/templates/dialog/template/delete.html',
        controller: 'DeletePresenterDialog',
        data: {
          object: template,
          type: 'template: ' + template.name
        }
      })
      .then(function (dialogData) {
        template.remove({ remove_children: dialogData ? dialogData.remove_children : false }).then(function () {
          $scope.loadPage($scope.page);
        });
      }, function () {
        return;
      });
  };

  $scope.goToAttachments = function (template, event) {
    if (!$scope.isTemplateExpanded(template)) {
      $scope.expandTemplate(template).then(function () {
        $timeout(function () {
          angular.element('.wrapper-columns-column.region-main .content-column').animate(
            {
              scrollTop:
                angular.element('.wrapper-attachment').offset().top +
                angular.element('.wrapper-columns-column.region-main .content-column').scrollTop() -
                150
            },
            'slow'
          );
        }, 1000);
      });
    } else {
      angular.element('.wrapper-columns-column.region-main .content-column').animate(
        {
          scrollTop:
            angular.element('.wrapper-attachment').offset().top +
            angular.element('.wrapper-columns-column.region-main .content-column').scrollTop() -
            150
        },
        'slow'
      );
    }
  };

  $scope.goToDynamicForm = function (template, event) {
    if (!$scope.isTemplateExpanded(template)) {
      $scope.expandTemplate(template).then(function () {
        $timeout(function () {
          angular.element('.wrapper-columns-column.region-main .content-column').animate(
            {
              scrollTop:
                angular.element('.widget-dynamic-form-selector.form-item').offset().top +
                angular.element('.wrapper-columns-column.region-main .content-column').scrollTop() -
                150
            },
            'slow'
          );
        }, 1000);
      });
    } else {
      angular.element('.wrapper-columns-column.region-main .content-column').animate(
        {
          scrollTop:
            angular.element('.widget-dynamic-form-selector.form-item').offset().top +
            angular.element('.wrapper-columns-column.region-main .content-column').scrollTop() -
            150
        },
        'slow'
      );
    }
  };

  $scope.isTemplateExpanded = function (template) {
    if (!$scope.templateExpanded) {
      return false;
    }
    return $scope.templateExpanded == template.id;
  };

  $scope.toggleSubcategory = function (subcategory, event) {
    angular.element('body').addClass('block-ui-visible');
    angular.element('body').addClass('block-ui-active');
    $timeout(function () {
      $scope.subcategoryExpanded = $scope.subcategoryExpanded == subcategory ? null : subcategory;
      angular.element('body').removeClass('block-ui-visible');
      angular.element('body').removeClass('block-ui-active');
      $timeout(function () {
        angular.element('.wrapper-columns-column.region-main .content-column').animate(
          {
            scrollTop:
              angular.element(event.target).offset().top + angular.element('.wrapper-columns-column.region-main .content-column').scrollTop() - 120
          },
          'slow'
        );
      }, 20);
    }, 20);
  };

  $scope.subcategoryIsExpanded = function (subcategory) {
    return $scope.subcategoryExpanded == subcategory;
  };

  $scope.anyRequired = function (templates) {
    var found = false;
    angular.forEach(templates, function (template) {
      if (template.required) {
        found = true;
      }
    });
    return found;
  };

  $scope.disableCloneTemplate = function (template) {
    if (AuthDataService.isAdmin() && template.client_instance) {
      return true;
    } else {
      return !template.editable && !template.overridable;
    }
  };

  $scope.disableToggleTemplate = function (template) {
    return !template.editable && !template.overridable;
  };

  $scope.toggleTemplate = function (template) {
    var status = template.status == TemplateService.STATUS_PUBLISHED ? TemplateService.STATUS_UNPUBLISHED : TemplateService.STATUS_PUBLISHED;
    template.changeStatus({ new_status: status }).then(function () {
      $scope.loadPage($scope.page);
    });
  };

  $scope.overrideToggleTemplate = function (template) {
    var status = template.status;
    switch (template.type.toString()) {
      case TemplateService.TYPE_ACCOUNT:
      case TemplateService.TYPE_ACCOUNT_USER:
      case TemplateService.TYPE_SYSTEM_WORKFLOW:
      case TemplateService.TYPE_ACCOUNT_WORKFLOW:
      case TemplateService.TYPE_TRIGGER:
        ngDialog
          .openConfirm({
            controller: 'PortfolioPropertySelectorDialog',
            templateUrl: 'views/templates/dialog/portfolio/selector.html',
            data: {
              account: template.account
            }
          })
          .then(function (results) {
            $scope.changeStatusNewMethod(template, results);
          }, function () {
            return;
          });
        break;
      case TemplateService.TYPE_PORTFOLIO:
        ngDialog
          .openConfirm({
            controller: 'PortfolioPropertySelectorDialog',
            templateUrl: 'views/templates/dialog/portfolio/selector.html',
            data: {
              account: template.account,
              portfoliosAvailable: PortfolioService.getlist({ id: template.portfolio, essential: true }, true),
              propertiesAvailable: PropertyService.getlist({ disable_pagination: true, portfolio__id: template.portfolio, essential: true }, true)
            }
          })
          .then(function (results) {
            $scope.changeStatusNewMethod(template, results);
          }, function () {
            return;
          });
        break;
      case TemplateService.TYPE_PROPERTY:
        status = template.status == TemplateService.STATUS_PUBLISHED ? TemplateService.STATUS_UNPUBLISHED : TemplateService.STATUS_PUBLISHED;
        template.changeStatus({ new_status: status, properties: [template.property] }).then(function () {
          $scope.loadPage($scope.page);
        });
        break;
      case TemplateService.TYPE_SYSTEM:
        status = template.status == TemplateService.STATUS_PUBLISHED ? TemplateService.STATUS_UNPUBLISHED : TemplateService.STATUS_PUBLISHED;
        template.changeStatus({ new_status: status }).then(function () {
          $scope.loadPage($scope.page);
        });
        break;
    }
  };

  $scope.initUsers = function (users) {
    var userIds = [];
    angular.forEach(users, function (user) {
      if (user) {
        if (user.id) {
          userIds.push(user.id);
        } else {
          userIds.push(user);
        }
      }
    });
    return userIds;
  };

  $scope.isTypeAccount = function (template) {
    var type = $filter('templateType')(template);
    return type === 'A' || type === 'S';
  };

  $scope.getData = function (template) {
    var data = angular.copy(template);

    data.account_users_assigned = $scope.initUsers(data.account_users_assigned);

    data.notify_to = [];

    angular.forEach(template.notify_to, function (email) {
      if (email) {
        data.notify_to.push(email);
      }
    });

    data.contact_types = [];

    angular.forEach(template.contact_types, function (type) {
      if (type) {
        data.contact_types.push(type.id);
      }
    });

    data.attachments = [];
    angular.forEach(template.attachments, function (attachment) {
      data.attachments.push(attachment.id ? attachment.id : attachment);
    });

    if (template.managed_by) {
      data['managed_by'] = template.managed_by.id;
    }

    if (template.approval_steps.length > 0) {
      angular.forEach(template.approval_steps, function (approval, index) {
        data['approval_steps'][index]['user_approvers'] = !isEmpty(approval.user_approvers)
          ? approval.user_approvers.map((item) => parseInt(item.id || item))
          : [];
        data['approval_steps'][index]['user_role_approvers'] = !isEmpty(approval.user_role_approvers)
          ? approval.user_role_approvers.map((item) => parseInt(item.id || item))
          : [];
        data['approval_steps'][index]['secondary_user_approvers'] = !isEmpty(approval.secondary_user_approvers)
          ? approval.secondary_user_approvers.map((item) => parseInt(item.id || item))
          : [];
        data['approval_steps'][index]['secondary_user_role_approvers'] = !isEmpty(approval.secondary_user_role_approvers)
          ? approval.secondary_user_role_approvers.map((item) => parseInt(item.id || item))
          : [];
      });
    }
    data.country = null;
    if (template.country) {
      data.country = (template.country.id ? template.country.id : template.country);
    }
    else {
      if (AuthDataService.authData.account) {
        data.country = (AuthDataService.authData.account.country.id ? AuthDataService.authData.account.country.id : AuthDataService.authData.account.country)
      }
    }
    data.levels = [];
    angular.forEach(template.levels, function (level) {
      if (level) {
        data.levels.push(level.id);
      }
    });
    data.roles = template.roles ? template.roles.map(item => item.id || item) : [];
    return data;
  };

  $scope.showCloneAdminDialog = function (template) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/admin/clone-element.html',
        controller: 'CloneTypeDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          type: 'template'
        }
      })
      .then(function (result) {
        if (result.type_result === 'client_instance') {
          template.cloneToWhiteLabel({ clientinstances: result.client_instance }).then(function () {
            $scope.loadPage($scope.page);
          });
        } else {
          $scope.clone(template);
        }
      }, function () {
        return;
      });
  };

  $scope.showClone = function (template) {
    if (AuthDataService.isAdmin()) {
      $scope.showCloneAdminDialog(template);
    } else {
      $scope.clone(template);
    }
  };

  $scope.clone = function (template) {
    TemplateService.get(template.id).then(function (data) {
      var templateData = $scope.getData(data);
      templateData['languages'] = (templateData['languages'] && templateData['languages'].length > 0) ? templateData['languages'].map(lang=> lang.id) : [];
      if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
        TemplateService.post(templateData).then(function () {
          $rootScope.$broadcast('template:created');
        });
      } else {
        if ($scope.templateMode === 'trigger') {
          templateData['type'] = TemplateService.TYPE_TRIGGER;
          templateData['account'] = AccountUserService.currentAccountUser.account;
          delete templateData['parent'];
          delete templateData['portfolio'];
          delete templateData['property'];
          TemplateService.post(templateData).then(function () {
            $rootScope.$broadcast('template-trigger:created');
          });
        } else if (templateData.root_group || !isNull(templateData.group)) {
          templateData['type'] = TemplateService.TYPE_ACCOUNT;
          TemplateService.post(templateData).then(function () {
            $rootScope.$broadcast('template:created');
          });
        } else {
          ngDialog
            .openConfirm({
              controller: 'PortfolioPropertySelectorDialog',
              templateUrl: 'views/templates/dialog/portfolio/selector.html',
              data: {
                clone: true,
                account: templateData.account,
                template: templateData
              }
            })
            .then(function (results) {
              var all = [];
              if (templateData.root_group || !isNull(templateData.group)) {
                templateData.name = results.name;
                all.push(TemplateService.post(templateData));
              } else if (results.type === 'account') {
                templateData['type'] = TemplateService.TYPE_ACCOUNT;
                templateData['account'] = AccountUserService.currentAccountUser.account;
                delete templateData['parent'];
                delete templateData['portfolio'];
                delete templateData['property'];
                templateData.name = results.name;
                all.push(TemplateService.post(templateData));
              } else {
                if (results.portfolios && results.portfolios.length > 0) {
                  angular.forEach(results.portfolios, function (portfolio) {
                    templateData['type'] = TemplateService.TYPE_PORTFOLIO;
                    templateData['portfolio'] = portfolio;
                    delete templateData['property'];
                    all.push(TemplateService.post(templateData, true));
                  });
                }
                if (results.properties) {
                  angular.forEach(results.properties, function (property) {
                    templateData['type'] = TemplateService.TYPE_PROPERTY;
                    templateData['property'] = property;
                    delete templateData['portfolio'];
                    all.push(TemplateService.post(templateData, true));
                  });
                }
              }
              $q.all(all).then(function () {
                $rootScope.$broadcast('template:created');
              });
            }, function () {
              return;
            });
        }
      }
    });
  };

  $scope.getLevelsIds = function (template) {
    var ids = [];
    if (template) {
      angular.forEach(template.levels, function (value) {
        ids.push(value.id);
      });
    }
    return ids;
  };

  $scope.getContactsIds = function (template) {
    var ids = [];
    if (template) {
      angular.forEach(template.contact_types, function (value) {
        ids.push(value.id);
      });
    }
    return ids;
  };

  $scope.enableAll = function (templates) {
    var enable = true;
    angular.forEach(templates, function (value) {
      if (value.status == TemplateService.STATUS_UNPUBLISHED) {
        enable = false;
      }
    });
    return enable;
  };

  $scope.toggleAll = function (templates, subcategory, status_all) {
    var status = null;
    var exist_filters = false;
    if (status_all) {
      status = status_all;
    } else {
      status = $scope.enableAll(templates) ? TemplateService.STATUS_UNPUBLISHED : TemplateService.STATUS_PUBLISHED;
    }

    if (
      FilterService.hasFilter('sector') ||
      FilterService.hasFilter('status') ||
      FilterService.hasFilter('account_reports') ||
      FilterService.hasFilter('group_reports') ||
      FilterService.hasFilter('portfolio_reports') ||
      FilterService.hasFilter('property_reports') ||
      FilterService.hasFilter('managed_by_reports') ||
      FilterService.hasFilter('type') ||
      FilterService.hasFilter('category') ||
      FilterService.hasFilter('subcategory') ||
      FilterService.hasFilter('recurrence_type') ||
      FilterService.hasFilter('property_type') ||
      FilterService.getFilter('name__icontains') ||
      FilterService.hasFilter('levels')
    ) {
      exist_filters = true;
    }

    ngDialog
      .openConfirm({
        controller: 'ChangeStatusTemplateDialog',
        templateUrl: 'views/templates/dialog/template/change-status.html',
        data: {
          status: status,
          filters: exist_filters
        }
      })
      .then(function () {
        var override = false;
        angular.forEach(templates, function (value) {
          if ($scope.overrideActive(value)) {
            override = true;
          }
        });
        if (override) {
          ngDialog
            .openConfirm({
              controller: 'PortfolioPropertySelectorDialog',
              templateUrl: 'views/templates/dialog/portfolio/selector.html',
              data: {
                noProperties: true
              }
            })
            .then(function (results) {
              TemplateService.changeStatusAll({
                name__icontains: FilterService.getFilter('name__icontains'),
                new_status: status,
                subcategory: FilterService.getFilter('subcategory'),
                portfolio_ids: results.portfolios,
                property_ids: results.properties,
                client_instance: FilterService.getFilter('client_instances', true),
                account: FilterService.getFilter('account_reports'),
                managed_by: FilterService.getFilter('managed_by_reports'),
                recurrence_type: FilterService.getFilter('recurrence_type'),
                group: FilterService.getFilter('group_reports'),
                property_type: FilterService.getFilter('property_type'),
                levels: FilterService.getFilter('levels'),
                category: FilterService.getFilter('category'),
                type: FilterService.getFilter('type')
              }).then(function () {
                $scope.loadPage($scope.page);
              });
            }, function () {
              return;
            });
        } else {
          TemplateService.changeStatusAll({
            name__icontains: FilterService.getFilter('name__icontains'),
            new_status: status,
            subcategory: FilterService.getFilter('subcategory'),
            client_instance: FilterService.getFilter('client_instances', true),
            account: FilterService.getFilter('account_reports'),
            managed_by: FilterService.getFilter('managed_by_reports'),
            portfolio: FilterService.getFilter('portfolio_reports'),
            property: FilterService.getFilter('property_reports'),
            recurrence_type: FilterService.getFilter('recurrence_type'),
            group: FilterService.getFilter('group_reports'),
            property_type: FilterService.getFilter('property_type'),
            levels: FilterService.getFilter('levels'),
            category: FilterService.getFilter('category'),
            type: FilterService.getFilter('type')
          }).then(function () {
            $scope.loadPage($scope.page);
          });
        }
      }, function () {
        return;
      });
  };

  $scope.disableToggleNoviceTemplate = function (template) {
    return !template.editable && !template.overridable;
  };

  $scope.toggleNovice = function (template) {
    var data = $scope.initData(template);
    data.novice = !template.novice;
    template.patch(data).then(function (result) {
      $scope.loadPage($scope.page);
      $rootScope.$broadcast('template-novice:toggled', result);
    });
  };

  $scope.overrideToggleNovice = function (template) {
    var data = $scope.initData(template);
    switch (template.type.toString()) {
      case TemplateService.TYPE_ACCOUNT:
      case TemplateService.TYPE_SYSTEM:
      case TemplateService.TYPE_ACCOUNT_USER:
      case TemplateService.TYPE_SYSTEM_WORKFLOW:
      case TemplateService.TYPE_ACCOUNT_WORKFLOW:
      case TemplateService.TYPE_TRIGGER:
        ngDialog
          .openConfirm({
            controller: 'PortfolioPropertySelectorDialog',
            templateUrl: 'views/templates/dialog/portfolio/selector.html',
            data: {
              account: template.account
            }
          })
          .then(function (results) {
            var all = [];
            var all_get = [];
            data.novice = !data.novice;
            if (results.portfolios) {
              angular.forEach(results.portfolios, function (portfolio) {
                var tempData = angular.copy(data);
                tempData['type'] = TemplateService.TYPE_PORTFOLIO;
                tempData['parent'] = template.id;
                tempData['portfolio'] = portfolio;
                all_get.push(
                  TemplateService.get(template.id, true).then(function (val) {
                    tempData.fields = val.fields;
                    all.push(TemplateService.post(tempData, true));
                  })
                );
              });
            }
            if (results.properties) {
              angular.forEach(results.properties, function (property) {
                var tempData1 = angular.copy(data);
                tempData1['type'] = TemplateService.TYPE_PROPERTY;
                tempData1['parent'] = template.id;
                tempData1['property'] = property;
                all_get.push(
                  TemplateService.get(template.id, true).then(function (res) {
                    tempData1.fields = res.fields;
                    all.push(TemplateService.post(tempData1, true));
                  })
                );
              });
            }
            $q.all(all_get).then(eventEmitForTemplateCreated(all));
          }, function () {
            return;
          });
        break;
      case TemplateService.TYPE_PORTFOLIO:
        ngDialog
          .openConfirm({
            controller: 'PortfolioPropertySelectorDialog',
            templateUrl: 'views/templates/dialog/portfolio/selector.html',
            data: {
              account: template.account,
              portfoliosAvailable: PortfolioService.getlist({ id: template.portfolio, essential: true }, true),
              propertiesAvailable: PropertyService.getlist({ disable_pagination: true, portfolio_id: template.portfolio, essential: true }, true)
            }
          })
          .then(function (results) {
            var all = [];
            var all_get = [];
            data.novice = !data.novice;
            if (results.portfolios) {
              angular.forEach(results.portfolios, function (portfolio) {
                var tempData2 = angular.copy(data);
                tempData2['type'] = TemplateService.TYPE_PORTFOLIO;
                tempData2['parent'] = template.id;
                tempData2['portfolio'] = portfolio;
                delete tempData2['property'];
                all_get.push(
                  TemplateService.get(template.id, true).then(function (res) {
                    tempData2.fields = res.fields;
                    all.push(TemplateService.post(tempData2, true));
                  })
                );
              });
            }
            if (results.properties) {
              angular.forEach(results.properties, function (property) {
                var tempData3 = angular.copy(data);
                tempData3['type'] = TemplateService.TYPE_PROPERTY;
                tempData3['parent'] = template.id;
                tempData3['property'] = property;
                delete tempData3['portfolio'];
                all_get.push(
                  TemplateService.get(template.id, true).then(function (res) {
                    tempData3.fields = res.fields;
                    all.push(TemplateService.post(tempData3, true));
                  })
                );
              });
            }
            $q.all(all_get).then(eventEmitForTemplateCreated(all));
          }, function () {
            return;
          });
        break;
      case TemplateService.TYPE_PROPERTY:
        var templateData = angular.copy(data);
        templateData['type'] = TemplateService.TYPE_PROPERTY;
        templateData['parent'] = template.id;
        templateData['property'] = template.property;
        delete templateData['portfolio'];
        TemplateService.get(template.id).then(function (result) {
          templateData.fields = result.fields;
          $rootScope.$broadcast('template:created');
        });
        break;
    }
  };

  $scope.getParams = function (parent_id) {
    var filters = {};
    filters['sector'] = FilterService.getFilter('sector') ? FilterService.getFilter('sector') : AccountUserService.currentAccountUser.sector;
    switch ($state.current.templateMode) {
      case 'owner':
        filters['type'] = TemplateService.TYPE_ACCOUNT_USER;
        break;
      case 'trigger':
        filters['type'] = TemplateService.TYPE_TRIGGER;
        break;
      default:
        filters['account'] = FilterService.getFilter('account_reports');
        filters['client_instance'] = FilterService.getFilter('client_instances', true);
        filters['group'] = FilterService.getFilter('group_reports');
        filters['portfolio'] = FilterService.getFilter('portfolio_reports');
        filters['property'] = FilterService.getFilter('property_reports');
        if (
          (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) &&
          !filters['account'] &&
          !filters['group'] &&
          !filters['portfolio'] &&
          !filters['property']
        ) {
          filters['type'] = TemplateService.TYPE_SYSTEM;
        }
        break;
    }

    if ($scope.template_group) {
      filters['group'] = parent_id;
    } else {
      filters['ancestor'] = parent_id;
    }
    if (FilterService.hasFilter('status')) {
      filters['status'] = FilterService.getFilter('status');
    } else {
      filters['status'] = TemplateService.STATUS_PUBLISHED + ',' + TemplateService.STATUS_UNPUBLISHED;
    }

    filters['ancestor'] = parent_id;
    if (!parent_id) {
      filters['exclude_children'] = true;
      filters['exclude_group'] = true;
    } else {
      filters['disable_pagination'] = true;
      $rootScope.$broadcast('disable_pagination', { disable_pagination: true });
    }

    if (FilterService.hasFilter('type')) {
      filters['type'] = FilterService.getFilter('type');
    }

    if (FilterService.hasFilter('levels')) {
      filters['levels'] = FilterService.getFilter('levels');
    }

    if (FilterService.hasFilter('category')) {
      filters['category'] = FilterService.getFilter('category');
    }

    if (FilterService.hasFilter('subcategory')) {
      filters['subcategory'] = FilterService.getFilter('subcategory');
    }

    if (FilterService.hasFilter('recurrence_type')) {
      filters['recurrence_type'] = FilterService.getFilter('recurrence_type');
    }

    if (FilterService.hasFilter('property_type')) {
      filters['property_type'] = FilterService.getFilter('property_type');
    }

    if (FilterService.hasFilter('managed_by_reports')) {
      filters['managed_by'] = FilterService.getFilter('managed_by_reports');
    }

    if (FilterService.hasFilter('name__icontains')) {
      filters['name__icontains'] = FilterService.getFilter('name__icontains');
    }

    if (FilterService.hasFilter('role')) {
      filters['roles'] = FilterService.getFilter('role');
    }

    return filters;
  };

  $scope.getProfundity = function () {
    var childTemplates = [];
    var templates = [];
    angular.forEach($scope.templates, function (template) {
      if (template.account_user) {
        AccountUserService.get(template.account_user, true).then(function (item) {
          template.user = item.user;
        });
      }
      if (!_.contains(childTemplates, template.id)) {
        template.depth = 0;
        templates.push(template);
        $scope.addChildren(templates, childTemplates, template, 1);
      }
    });
    return templates;
  };

  $scope.addChildren = function (templates, childTemplates, template, level) {
    angular.forEach(template.children, function (childId) {
      for (var i = templates.length - 1; i >= 0; i--) {
        if (templates[i].id === childId) {
          templates.splice(i, 1);
        }
      }
      childTemplates.push(childId);
      var child = $scope.templates.filter(function (obj) {
        return obj.id === childId;
      });
      if (child.length) {
        child = child[0];
        child.depth = level;
        templates.push(child);
        $scope.addChildren(templates, childTemplates, child, level + 1);
      }
    });
  };

  $scope.getPriorityColor = function (template) {
    if (template.priority !== null && template.priority !== undefined && template.priority !== '')
      switch (template.priority.toString()) {
        case TemplateService.PRIORITY_MINOR:
          return 'successColor';
        case TemplateService.PRIORITY_NORMAL:
          return 'warningColor';
        case TemplateService.PRIORITY_CRITICAL:
          return 'errorColor';
      }
    return '';
  };

  $scope.getIndexSubCategory = function (subcategory) {
    var index = -1;
    angular.forEach($scope.templatesGrouped, function (group, key) {
      if (group.subcategory === subcategory) index = key;
    });
    return index;
  };

  $scope.groupTemplates = function () {
    $scope.templatesGrouped = [];

    angular.forEach($scope.templates, function (template) {
      if (
        $scope.templatesGrouped
          .map(function (t) {
            return t.subcategory;
          })
          .indexOf(template.subcategory) < 0
      ) {
        $scope.templatesGrouped.push({
          subcategory: template.subcategory,
          templates: []
        });
      }
      if (
        $scope.templatesGrouped[$scope.getIndexSubCategory(template.subcategory)].templates
          .map(function (t) {
            return t.id;
          })
          .indexOf(template.id) < 0
      ) {
        $scope.templatesGrouped[$scope.getIndexSubCategory(template.subcategory)].templates.push(template);
      }
    });
    if ($scope.templatesGrouped.length === 1) {
      $scope.subcategoryExpanded = $scope.templatesGrouped[0].subcategory;
    }
  };

  $scope.isCategoryCode = function (template) {
    return template.category && template.category.toString() === $scope.templateService.CATEGORY_CODE;
  };

  $scope.getGroupChildren = function (templates) {
    var children = [];
    angular.forEach(templates, function (template) {
      if (template.group) children.push(template.id);
    });
    return children;
  };

  $scope.getEntitiesPromise = function (options) {
    var params = $scope.getParams($stateParams.id);
    angular.forEach(params, function (value, key) {
      options[key] = value;
    });
    if (FilterService.getFilter('group_subcategory')) {
      options['ordering'] = 'subcategory__name,name,parent';
    } else if (!options['ordering']) {
      options['ordering'] = 'name,parent';
    } else {
      options['ordering'] += ',parent';
    }
    var defer = $q.defer();
    var promises = [];
    if ($stateParams.id) {
      promises.push(TemplateService.get($stateParams.id, true));
    }
    $scope.options = options;
    promises.push(TemplateService.getlist(options));

    $q.all(promises).then(
      function (data) {
        $scope.templateExpanded = null;
        $scope.templates = [];
        var results = [];
        if ($stateParams.id) {
          $scope.template_parent = data[0];
          $rootScope.$broadcast('parent_name', $scope.template_parent);
          results = data[1].results ? data[1].results : data[1];
        } else {
          results = data[0].results ? data[0].results : data[0];
        }
        if ($scope.template_parent) $scope.templates.push($scope.template_parent);
        angular.forEach(results, function (value) {
          var exist = false;
          angular.forEach($scope.templates, function (value_aux) {
            if (value.id === value_aux.id) exist = true;
          });
          if (!exist) $scope.templates.push(value);
        });
        if ($scope.template_parent && $scope.template_group) {
          $scope.templates[0].children = $scope.getGroupChildren(results);
        }
        $scope.templates = $scope.getProfundity();
        if ($scope.template_parent) {
          data[1]['meta'].count += 1;
          $scope.tableFilterSize = data[1].meta.count;
          $scope.templates['meta'] = data[1]['meta'];
        } else {
          $scope.templates['meta'] = data[0]['meta'];
        }
        if (FilterService.getFilter('group_subcategory')) {
          $scope.group = true;
          $scope.groupTemplates();
        } else {
          $scope.group = false;
        }
        defer.resolve($scope.templates);
      },
      function (error) {
        defer.reject(error);
      }
    );
    return defer.promise;
  };

  $scope.changeStatusNewMethod = function(template, results){
    let newstatus = template.status == TemplateService.STATUS_PUBLISHED ? TemplateService.STATUS_UNPUBLISHED : TemplateService.STATUS_PUBLISHED;
    template
      .changeStatus({
        new_status: newstatus,
        portfolios: results?.type == "account" ? [] : results.portfolios,
        properties: results?.type == "account" ? [] : results.properties
      })
      .then(function () {
        $scope.loadPage($scope.page);
      });
  }

  function listenerForTemplateCreated(){
    ngDialog.closeAll();
    $scope.templateExpanded = null;
    $scope.loadPage($scope.page);
  }
  
  function eventEmitForTemplateCreated(all){
    $q.all(all).then(function () {
      $rootScope.$broadcast('template:created');
    });
  }
  $scope.$on('templates-status:updated', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('template:updated', function ($event, template) {
    $scope.templateExpanded = null;
    $scope.loadPage($scope.page);
  });

  $scope.$on('template:created', listenerForTemplateCreated);

  $scope.$on('template-trigger:created', listenerForTemplateCreated);

  $controller('TableFilterController', { $scope: $scope });

  if ($stateParams.id) {
    $scope.loadPage($scope.page);
  }
};

app.controller('TemplateList', [
  '$scope',
  '$filter',
  '$timeout',
  '$q',
  '$controller',
  '$stateParams',
  '$rootScope',
  'ngDialog',
  'TemplateService',
  'FilterService',
  '$state',
  'PermissionService',
  'AttachmentService',
  'AccountUserService',
  'AuthDataService',
  'PortfolioService',
  'PropertyService',
  'BrowserHistoryService',
  TemplateList
]);
